export const SEGMENTS = {
    signup: {
        id: 'GTM-MSQNLTG',
    },
    'non-signup': {
        id: 'GTM-KCR76K3',
    },
};
